import {
  ALL_TASKS,
  CLEANING_TASKS,
  DELIVERY_TASKS,
  DROP_STRIPS_TASKS,
  MAINTENANCE_TASKS,
  FINAL_INSPECTION_TASKS,
  GLASS_LANAI_TASKS,
  GUEST_EXPERIENCE_TASKS,
  HOUSEKEEPING_TASKS,
  MAINTENANCE_INSPECTION_TASKS,
  MY_TASKS,
  OVERDUE_TASKS,
  OWNER_EXPERIENCE_TASKS,
  SHUTTLE_SERVICE_TASKS,
  SPECIAL_PROJECT_TASKS,
  UNASSIGNED_TASKS,
} from "./path-config";
import { getSelectedBrandFromCookie } from "../utils/brand-selector";
import { environment } from "./";

// Domain constants for brand validation
export const domainMRR = 'ohana.mauiresortrentals.com';
export const domainBVR = 'ohana.beachviewrentals.com';

// Define your branding configurations for different domains here
const brands: Record<string, BrandConfig> = {
  [domainMRR]: {
    portalName: "ohana",
    timezone: "Pacific/Honolulu",
    title: "Maui Resort Rentals",
    companyName: "Maui Resort Rentals, Inc.",
    description: "",
    greeting: "Aloha",
    greetingLong: "Aloha and Welcome!",
    brandId: "49017bd8-7ce6-40bd-952e-0b4a1429b19b",
    code: "MRR",
    appleIconUrl: "/mrr/apple-touch-icon.png",
    logoUrl: "/mrr/logo-full-white.svg",
    iconUrl: "/mrr/geo-icon-white.svg",
    loadingImageUrl: "/mrr/geo-icon.svg",
    favIconUrl: "/mrr/favicon.ico",
    shortcutIconUrl: "/mrr/favicon-32x32.png",
    customCssUrl: "/mrr/style.css",
    sitemanifestUrl: "/mrr/site.webmanifest.json",
    domain: "mauiresortrentals.com",
    email: "devops@mauiresortrentals.com",
    locale: "Maui",
    resortFilterLabel: "task_filter_group_resort",
    buildingFilterLabel: "task_filter_group_building",
    listingFilterLabel: "task_filter_group_listings",
    showResortFilter: true,
    showBuildingFilter: true,
    showListingFilter: true,
    address: {
      streetAddress: "10 Halawai Dr #A-3",
      city: "Lahaina",
      state: "HI",
      postalCode: "96761",
    },
    themeSettings: {
      themeColorPresets: "default",
    },
    phone: "+18086887538",
    phoneDisplay: "(808) 688-7538",
    phoneTollFree: "+18558086284",
    phoneTollFreeDisplay: "(855) 808-MAUI (6284)",
    sendGrid: {
      clientUrl: "https://mauiresortrentals.com",
      fromEmail: "Maui Resort Rentals <noreply@mauiresortrentals.com>",
      templateIds: {
        otp: "d-dc7a77974dd14944934f0d648322c386",
      },
    },
    listTaskViews: [
      MY_TASKS,
      ALL_TASKS,
      UNASSIGNED_TASKS,
      OVERDUE_TASKS,
      DROP_STRIPS_TASKS,
      GLASS_LANAI_TASKS,
      MAINTENANCE_INSPECTION_TASKS,
      CLEANING_TASKS,
      FINAL_INSPECTION_TASKS,
      SPECIAL_PROJECT_TASKS,
      DELIVERY_TASKS,
      SHUTTLE_SERVICE_TASKS,
      MAINTENANCE_TASKS,
      HOUSEKEEPING_TASKS,
      GUEST_EXPERIENCE_TASKS,
      OWNER_EXPERIENCE_TASKS,
    ],
    termsAndConditions:
      "https://www.mauiresortrentals.com/terms-and-conditions",
    privacyPolicy: "https://www.mauiresortrentals.com/privacy-policy",
  },
  [domainBVR]: {
    portalName: "ohana",
    timezone: "America/Los_Angeles",
    title: "Beachview Rentals",
    companyName: "Dream Resort Rentals, Inc.",
    description: "",
    greeting: "Welcome",
    greetingLong: "Welcome!",
    brandId: "55d26c7f-eb8d-4f82-937b-8b4c3ca7c709",
    code: "BVR",
    appleIconUrl: "/bvr/apple-touch-icon.png",
    logoUrl: "/bvr/logo.svg",
    iconUrl: "/bvr/geo-icon-white.svg",
    loadingImageUrl: "/bvr/geo-icon.svg",
    favIconUrl: "/bvr/favicon.ico",
    shortcutIconUrl: "/bvr/favicon-32x32.png",
    customCssUrl: "/bvr/style.css",
    sitemanifestUrl: "/bvr/site.webmanifest.json",
    domain: "beachviewrentals.com",
    email: "devops@beachviewrentals.com",
    locale: "Newport Beach",
    resortFilterLabel: "task_filter_group_area",
    buildingFilterLabel: "task_filter_group_building",
    listingFilterLabel: "task_filter_group_listings",
    showResortFilter: true,
    showBuildingFilter: false,
    showListingFilter: true,
    address: {
      streetAddress: "314 Old Newport Blvd",
      city: "Newport Beach",
      state: "CA",
      postalCode: "92663",
    },
    themeSettings: {
      themeColorPresets: "default",
    },
    phone: "+19496732627",
    phoneDisplay: "(949) 673-2627",
    phoneTollFree: "TOLL FREE PHONE",
    phoneTollFreeDisplay: "TOLL FREE PHONE DISPLAY",
    sendGrid: {
      clientUrl: "https://beachviewrentals.com",
      fromEmail: "Beachview Rentals <noreply@beachviewrentals.com>",
      templateIds: {
        otp: "d-5eb676878be44ddea65c527cb999a4e7",
      },
    },
    listTaskViews: [
      MY_TASKS,
      ALL_TASKS,
      UNASSIGNED_TASKS,
      OVERDUE_TASKS,
      GLASS_LANAI_TASKS,
      MAINTENANCE_INSPECTION_TASKS,
      CLEANING_TASKS,
      FINAL_INSPECTION_TASKS,
      SPECIAL_PROJECT_TASKS,
      DELIVERY_TASKS,
      MAINTENANCE_TASKS,
      HOUSEKEEPING_TASKS,
      GUEST_EXPERIENCE_TASKS,
      OWNER_EXPERIENCE_TASKS,
    ],
    termsAndConditions:
      "https://beachviewrealty.com/additional-information/terms-and-conditions",
    privacyPolicy:
      "https://beachviewrealty.com/additional-information/privacy-policy",
  },
  default: {
    portalName: "ops",
    title: "Dream Resorts",
    timezone: "UTC",
    companyName: "Dream Resorts, Inc.",
    description: "",
    greeting: "Hello",
    greetingLong: "Hello!",
    brandId: "abbfaa7b-89c6-4665-804c-55c47219ed1c",
    code: "DRS",
    appleIconUrl: "/drr/apple-touch-icon.png",
    logoUrl: "/drr/logo.png",
    iconUrl: "/mrr/logo.svg",
    favIconUrl: "/drr/favicon.ico",
    loadingImageUrl: "/mrr/geo-icon.svg",
    shortcutIconUrl: "/drr/favicon-16x16.png",
    customCssUrl: "/drr/style.css",
    sitemanifestUrl: "/drr/site.webmanifest.json",
    domain: "dreamresorts.com",
    email: "support@dreamresorts.com",
    locale: "Anywhere",
    showResortFilter: false,
    showBuildingFilter: false,
    showListingFilter: false,
    address: {
      streetAddress: "123 Anytown",
      city: "Lahaina",
      state: "HI",
      postalCode: "96761",
    },
    themeSettings: {
      themeColorPresets: "default",
    },
    phone: "+18086887538",
    phoneDisplay: "(808) 688-7538",
    phoneTollFree: "+18558086284",
    phoneTollFreeDisplay: "(855) DREAM-BIG",
    sendGrid: {
      clientUrl: "https://dreamresorts.com",
      fromEmail: "Dream Resorts <noreply@dreamresorts.com>",
      templateIds: {
        otp: "d-dc7a77974dd14944934f0d648322c386",
      },
    },
    listTaskViews: [MY_TASKS, ALL_TASKS, UNASSIGNED_TASKS, OVERDUE_TASKS],
    termsAndConditions: "",
    privacyPolicy: "",
  },
};

// Determine the current hostname based on the new requirements
function determineCurrentHostname(): string {
  const actualHostname = window.location.hostname;

  // In development mode, prioritize cookie-based brand selection
  if (environment.debugMode) {
    const cookieBrand = getSelectedBrandFromCookie();
    if (cookieBrand) {
      return cookieBrand;
    }
    // If no cookie is set in dev mode, we'll let the normal logic continue
    // This allows for the redirect logic to work properly
  }

  // If the user's host exactly matches our defined brand URLs, no changes
  if (actualHostname === domainBVR || actualHostname === domainMRR) {
    return actualHostname;
  }

  // If the user comes from any "*.ohana-portal-remote.pages.dev", allow them into the app
  // For those users, decide their brand based on the value of process.env.REACT_APP_HOSTNAME
  if (actualHostname.endsWith('.ohana-portal-remote.pages.dev')) {
    return process.env.REACT_APP_HOSTNAME || actualHostname;
  }

  // If the user comes from an unknown/unsupported host, check only against process.env.REACT_APP_HOSTNAME
  // and fail if that variable is missing/empty
  if (!process.env.REACT_APP_HOSTNAME) {
    throw new Error('REACT_APP_HOSTNAME environment variable is required for unsupported hosts.');
  }
  return process.env.REACT_APP_HOSTNAME;
}

const host = determineCurrentHostname();
const brand = brands[host] || brands.default;

export default brand;
